import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

class Lightbox extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.getElementById('messages-list').style.overflowY = "hidden"; 
		window.addEventListener("keydown", this.handleKeyDown.bind(this));
	}

	componentWillUnmount() {
		document.getElementById('messages-list').style.overflowY = "scroll"; 
		window.removeEventListener("keydown", this.handleKeyDown);
	}

	handleKeyDown(e) {
		if (e.keyCode === 27) {
			this.props.closeLightbox();
		}
	}

	render() {
		return (
			<div className="lightbox-container" 
				style={[styles.lightbox]}
				onClick={this.props.closeLightbox}
			>
				<img 
					src="https://d124s1zbdqkqqe.cloudfront.net/CloseButton.svg" 
					alt="" 
					className="lightbox-container__close" 
					style={[styles.lightbox.close]} 
					onClick={this.props.closeLightbox} 
				/>
				{this.props.message.get("type") === "picture" &&
					<img 
						src={this.props.message.get("url")} 
						alt="" 
						className="lightbox-container__image" 
						style={[styles.lightbox.image]}
						onClick={(e) => e.stopPropagation()}
					/>
				}
				{this.props.message.get("type") === "video" &&
					<video 
						src={this.props.message.get("vidUrl")} 
						className="lightbox-container__video"
						style={[styles.lightbox.image]}
						autoPlay="true" 
						loop="true"
						onClick={(e) => e.stopPropagation()}
					>
					</video>
				}
			</div>
		)
	}
}

const styles = {
	lightbox: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.8)',
		zIndex: '1',

		close: {
			position: 'absolute',
			top: '12px',
			right: '12px',
			opacity: '0.75',
			cursor: 'pointer',
			height: '24px',
			zIndex: '3',

			':hover': {
				opacity: '1'
			}
		},

		image: {
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',
			maxWidth: '90%',
			maxHeight: '90%',
			borderRadius: '12px',
			overflow: 'hidden',
			zIndex: '2',
			boxShadow: '0px 0px 10px 5px rgba(0,0,0,0.15)'
		}
	}
}


export default Radium(Lightbox);


// WEBPACK FOOTER //
// ./src/components/Lightbox.js